const documentTypes = [
    { key: 'CC', value: 'CC', text: 'Cédula de Ciudadanía' },
    { key: 'CE', value: 'CE', text: 'Cédula de Extranjería' },
    { key: 'PEP', value: 'PEP', text: 'Permiso Especial de Permanencia' },
    { key: 'TI', value: 'TI', text: 'Tarjeta de Identidad' },
    { key: 'NIT', value: 'NIT', text: 'Número de Identificación Tributaria' }
  ];
  
  export default documentTypes;
  